import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDownsampling = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 5.292 5.292",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5,
		strokeWidth: .185,
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M.599.599h4.093v4.093H.599z" }),
			/* @__PURE__ */ _jsx("path", { d: "M.656 2.072H3.22v2.6" }),
			/* @__PURE__ */ _jsx("path", { d: "M.65 3.178h1.465V4.67" })
		]
	})
});
export default SvgIconDownsampling;
